import React from "react";
import PropTypes from "prop-types";
import { ErrorMessage } from "../ErrorMessage";
import { numberOrZero } from "../../helpers/number";

const variants = {
  outline: { indigo_A700_01: "border bg-white-A700 border-solid" },
  error: { border_red_700: "border bg-white-A700 border-red-500 border-solid" },
  fill: { white_A700: "bg-white-A700 border border-solid" },
};
const shapes = { round: "rounded-lg" };
const sizes = {
  xs: "pb-[9px] pt-[11px] px-[9px]",
  sm: "pb-[15px] pt-[17px] px-[15px]",
};

const Input = React.forwardRef(
  (
    {
      wrapClassName = "",
      className = "",
      name = "",
      value,
      readonly = false,
      placeholder = "",
      type = "text",
      children,
      errors = [],
      label = "",
      prefix,
      suffix,
      onChange,
      shape = "",
      size = "",
      variant = "",
      color = "",
      lines=1,
      ...restProps
    },
    ref,
  ) => {
    const handleChange = (e) => {
      if (onChange) onChange(e?.target?.value);
    };

    return (
      <>
        <div
          className={`${wrapClassName} 
              ${shapes[shape] || ""} 
              ${variants[variant]?.[color] || ""} 
              ${sizes[size] || ""}`}
        >
          {!!label && label}
          {!!prefix && prefix}
          {
            numberOrZero(lines)>1?(
              <textarea
                ref={ref}
                rows={lines}
                readOnly={readonly===true}
                className={`${className} bg-transparent border-0`}
                name={name}
                value={value}
                onChange={handleChange}
                placeholder={placeholder}
                {...restProps}
              />
            ): (
              <input
                ref={ref}
                className={`${className} bg-transparent border-0`}
                type={type}
                value={value}
                readOnly={readonly===true}
                name={name}
                onChange={handleChange}
                placeholder={placeholder}
                {...restProps}
              />
            )
          }
          {!!suffix && suffix}
        </div>
        {!!errors && <ErrorMessage errors={errors} />}
      </>
    );
  },
);

Input.propTypes = {
  wrapClassName: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  shape: PropTypes.oneOf(["round"]),
  size: PropTypes.oneOf(["xs", "sm"]),
  variant: PropTypes.oneOf(["outline", "fill","error"]),
  color: PropTypes.oneOf(["indigo_A700_01", "white_A700","border-red-700"]),
};

export { Input };
